import { atom } from "jotai";
import {
    startOfWeek,
    endOfWeek,
    startOfDay,
    endOfDay,
    format
} from "date-fns";

// View mode: "Week" or "Day"
export const calendarViewAtom = atom("Week");

// The anchor date for the calendar (what week/day is being viewed)
export const calendarDateAtom = atom(new Date());

// Selected providers: array of { id, firstname, lastname, timezone, emailaddress }
export const calendarSelectedProvidersAtom = atom([]);

// Cell duration in minutes: 30 or 60
export const calendarCellDurationAtom = atom(60);

// Derived: computes the date range for the current view
export const calendarDateRangeAtom = atom((get) => {
    const date = get(calendarDateAtom);
    const view = get(calendarViewAtom);

    if (view === "Day") {
        return {
            startDate: format(startOfDay(date), "yyyy-MM-dd'T'00:00:00"),
            endDate: format(endOfDay(date), "yyyy-MM-dd'T'23:59:59")
        };
    }

    // Week view: Monday to Sunday
    const weekStart = startOfWeek(date, { weekStartsOn: 1 });
    const weekEnd = endOfWeek(date, { weekStartsOn: 1 });
    return {
        startDate: format(weekStart, "yyyy-MM-dd'T'00:00:00"),
        endDate: format(weekEnd, "yyyy-MM-dd'T'23:59:59")
    };
});

// Weekend visibility
export const calendarShowSaturdayAtom = atom(true);
export const calendarShowSundayAtom = atom(true);

// Calendar loading state (for UI feedback beyond React Query)
export const calendarRefetchTriggerAtom = atom(0);
